import gaHelper from '../../helpers/gaHelper';
import identityConstants from '../constants/identity.constants';
import identityService from '../services/identity.service';

const identityActions = {
  getInvitationDetails,
  joinWorkspace,
  registerIntoWorkspace,
  registerToJoinDocument,
  acceptCertificateInvitation,
};

function getInvitationDetails(token) {
  return (dispatch) => {
    dispatch({ type: identityConstants.FETCH_INVITATION_DETAILS_REQUEST });
    identityService
      .getInvitationStatus(token)
      .then((response) => {
        dispatch({
          type: identityConstants.FETCH_INVITATION_DETAILS_SUCCESS,
          invitationDetails: response.data,
        });
      })
      .catch(() => {
        dispatch({ type: identityConstants.FETCH_INVITATION_DETAILS_FAILURE });
      });
  };
}

function joinWorkspace(inviteId) {
  return (dispatch) => {
    dispatch({ type: identityConstants.JOIN_WORKSPACE_REQUEST });
    identityService
      .joinWorkspace(inviteId)
      .then((response) => {
        dispatch({ type: identityConstants.JOIN_WORKSPACE_SUCCESS, identityData: response.data });
      })
      .catch(() => {
        dispatch({ type: identityConstants.JOIN_WORKSPACE_FAILURE });
      });
  };
}

function registerIntoWorkspace(inviteId, language, captchaToken) {
  return (dispatch) => {
    dispatch({ type: identityConstants.REGISTER_INTO_WORKSPACE_REQUEST });
    identityService
      .registerIntoWorkspace(inviteId, language, captchaToken)
      .then((response) => {
        dispatch({
          type: identityConstants.REGISTER_INTO_WORKSPACE_SUCCESS,
          confirmCode: response.data.data.activationCode,
        });
        gaHelper.initialize();
        gaHelper.sendEvent('RegistrationStarted');
      })
      .catch((error) => {
        dispatch({
          type: identityConstants.REGISTER_INTO_WORKSPACE_FAILURE,
          error: error?.response?.data?.errors,
        });
      });
  };
}
function registerToJoinDocument(inviteId, service, language, captchaToken) {
  return (dispatch) => {
    dispatch({ type: identityConstants.REGISTER_INTO_WORKSPACE_REQUEST });
    identityService
      .registerToJoinDocument(inviteId, service, language, captchaToken)
      .then((response) => {
        dispatch({
          type: identityConstants.REGISTER_INTO_WORKSPACE_SUCCESS,
          confirmCode: response.data.data.activationCode,
        });
        gaHelper.initialize();
        gaHelper.sendEvent('RegistrationStarted');
      })
      .catch((error) => {
        dispatch({
          type: identityConstants.REGISTER_INTO_WORKSPACE_FAILURE,
          error: error?.response?.data?.errors,
        });
      });
  };
}

function acceptCertificateInvitation(transactionId, role, pin) {
  return (dispatch) => {
    dispatch({ type: identityConstants.ACCEPT_CERTIFICATE_INVITATION_REQUEST });
    identityService
      .acceptCertificateInvitation(transactionId, role, pin)
      .then((response) => {
        dispatch({
          type: identityConstants.ACCEPT_CERTIFICATE_INVITATION_SUCCESS,
          identityData: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: identityConstants.ACCEPT_CERTIFICATE_INVITATION_FAILURE,
          error: error?.response?.data?.errors,
        });
      });
  };
}

export default identityActions;
